export const MENU_SIZE = {
    MINI: 'mini',
    EXTENDED: 'extended'
}

export const THEME_MODE = {
    LIGHT: 'light',
    DARK: 'dark'
}

export const COLORS = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error'
}

export const COLOR_TONES = {
    LIGHTER: 'lighter',
    LIGHT: 'light',
    MAIN: 'main',
    DARK: 'dark',
    DARKER: 'darker',
    CONTRAST_TEXT: 'contrastText'
}
